/*
* Usage:
* import runtimeConfig from '@utils/runtime-config.ts';
* */

const runtimeConfig = {
  ...window.$vcrConfig,
};
export default runtimeConfig;
